"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var objectAssign = require('es6-object-assign');
objectAssign.polyfill();
var SimpleToggle = (function () {
    function SimpleToggle(toggleButtonSelector, targetSelector, options) {
        this.options = {
            buttonToggleClassName: 'toggle',
            targetToggleClassName: 'toggled',
            preventDefault: true
        };
        if (options) {
            this.options = Object.assign(this.options, options);
        }
        var toggleButtons = document.querySelectorAll(toggleButtonSelector);
        var toggleTargets = document.querySelectorAll(targetSelector);
        this.handleClick(toggleButtons, toggleTargets);
    }
    SimpleToggle.prototype.handleClick = function (buttonNodes, targetNodes) {
        var _this = this;
        var count = buttonNodes.length;
        for (var i = 0; i < count; ++i) {
            buttonNodes.item(i).addEventListener('click', function (e) {
                if (_this.options.preventDefault) {
                    e.preventDefault();
                }
                _this.toggleButtons(buttonNodes);
                _this.toggleTargets(targetNodes);
            });
        }
    };
    SimpleToggle.prototype.toggleButtons = function (buttonNodes) {
        var count = buttonNodes.length;
        for (var i = 0; i < count; ++i) {
            buttonNodes.item(i).classList.toggle(this.options.buttonToggleClassName);
        }
    };
    SimpleToggle.prototype.toggleTargets = function (targetNodes) {
        var count = targetNodes.length;
        for (var i = 0; i < count; ++i) {
            targetNodes.item(i).classList.toggle(this.options.targetToggleClassName);
        }
    };
    return SimpleToggle;
}());
exports.default = SimpleToggle;
